var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.13 59.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5b3d3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7.41c3.3-10.19,32.63-9.83,65.52.81s56.87,27.53,53.58,37.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.13,11.71c-2.54-10.4-31.82-12.18-65.4-4S213,31,215.53,41.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.27,31.13a39,39,0,0,1,.44,7.71,37.94,37.94,0,0,1-1,7.71A28,28,0,0,1,129,53.83c-.32.57-.71,1.1-1.06,1.64a11.16,11.16,0,0,1-1.2,1.54,17.72,17.72,0,0,1-2.87,2.61,23.67,23.67,0,0,0,4.45-6.15,35.37,35.37,0,0,0,2.47-7.15A55.68,55.68,0,0,0,132,38.79c.14-1.26.2-2.54.25-3.82S132.28,32.41,132.27,31.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.57,31.13a36.8,36.8,0,0,0,.9,3.62c.33,1.2.71,2.38,1.15,3.54A42.4,42.4,0,0,0,205.78,45a29.74,29.74,0,0,0,4.51,5.79L211.64,52c.47.39,1,.73,1.48,1.11l.74.56.8.48c.54.31,1.07.63,1.61,1a20.34,20.34,0,0,1-6.5-3.81,24,24,0,0,1-4.84-5.84,31.73,31.73,0,0,1-3-6.94A30.2,30.2,0,0,1,200.57,31.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset44);
export default __webpack_public_path__ + "static/media/Asset 44.262cdb27.svg";
export { ForwardRef as ReactComponent };